import React from 'react';
import LeftDrawer from '../NavBar/LeftDrawer';
import Appbar from '../NavBar/Appbar';
import MyCarousel from '../CarouselElements/MyCarousel';
import BackButton from '../NavBar/BackButton';
import SendDialog from '../NavBar/SendDialog';
import SelectDialog from '../NavBar/SelectDialog/';
import BetterTabs from '../NavBar/SelectDialog/BetterTabs.js';
import { Radio } from 'antd';
import './pillcards.css';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import home from "../icons/home.png";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const ColorButton = withStyles(theme => ({
  root: {
    color: theme.palette.getContrastText(blue[600]),
    backgroundColor: blue[600],
    '&:hover': {
      backgroundColor: blue[700],
    },
  },
}))(Button);

/* copy this methodology for the side effects */
const toTreeStructure = (classobj) => {
  var TreeStructure = {
    "Med_Name": classobj.Med_Class,
    "children": []
  }
  var arrayOfMeds = classobj.pills
  for (var j = 0; j < arrayOfMeds.length; j++) {
    TreeStructure.children.push({"Med_Name": arrayOfMeds[j].Med_Name_Generic})
  }
  return TreeStructure
}

const shallowToTree = (classobj) => {
  var TreeStructure = [];
  var arrayOfMeds = classobj.Med_List.split(',')
  for (var j = 0; j < arrayOfMeds.length; j++) {
    TreeStructure.push({"Med_Name": arrayOfMeds[j]})
  }
  return TreeStructure
}

const removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

class Pillcards extends React.Component {
  //True for switch means Classes
  constructor(props) {
    super(props)
    let priceTypes = ["prices"]
    if (this.props.va) {
      priceTypes.push("va_formulary")
    } else {
      priceTypes.push("medicaid")
    }
    let treatTypes = ["fda", "offlabel"]
    // let treatDescriptions = ["fda description", "offlabel description"]
    this.handler = this.handler.bind(this)
    this.classhandler = this.classhandler.bind(this)
    this.designatedClearHandler = this.designatedClearHandler.bind(this)
    this.designatedDefaultHandler = this.designatedDefaultHandler.bind(this)
    this.designatedDefaultClassHandler = this.designatedDefaultClassHandler.bind(this)
    this.handleSwitch = this.handleSwitch.bind(this)
    this.handleLanguage = this.handleLanguage.bind(this)
    this.handle_logout = this.handle_logout.bind(this)
    this.handleComorbs = this.handleComorbs.bind(this)
    this.handleTreat = this.handleTreat.bind(this)
    this.handleSideEffects = this.handleSideEffects.bind(this)
    this.handleCost = this.handleCost.bind(this)
    this.removePillcardHandler = this.removePillcardHandler.bind(this)
    this.updatePillcardObjectHandler = this.updatePillcardObjectHandler.bind(this)
    this.state = {
      selectedItems: [],
      selectedClasses: [],
      checkedKeys: [],
      //whether to show preferred and ruled out drug classes
      showClass: this.props.match.params.id
        ? true
        : false,
      designatedHandler: this.handler,
      switchOption: false,
      language: 'eng',
      costTypes: priceTypes,
      treatTypes: treatTypes,
      currCostTypeIndex: 1,
      currSideEffectIndex: 1,
      currTreatTypeIndex: 0,
      //whether we are va or not
      va: this.props.va,
      pillcardsobj: [],
      classcardsobj: [],
      priorities: [],
      allpillnames: [],
      isLoading: true,
      logged_in: localStorage.getItem('token') ? true : false,
      username: '',
    };
  }



  componentWillMount() {
    const {type, va} = this.props;
    var that = this;
    let classes;
    let pills;

    if (va) that.setState({"cost": "va"});

    // CACHED VERSION
    if (type === "diabetes"){
      if(va) {
        fetch("data/Diabetes_VA.json")
        .then(r => r.json())
        .then(data => {
          that.processDiabetes(that, data);
        });
      } else {
        fetch("data/Diabetes.json")
        .then(r => r.json())
        .then(data => {
          that.processDiabetes(that, data);
        });
      }
    } else if (type === "addiction") {
      fetch("data/Addiction.json")
        .then(r => r.json())
        .then(data => {
          //Set Up The Tree
          classes = data["classes"];
          pills = data["pills"];
          that.setState({"pillcardsobj": pills, "classcardsobj": classes});
          let alcoholtree = shallowToTree(classes[0]);
          that.setState({"priorities": alcoholtree});
          //Show the default settings
          let preselectedMeds = pills.map((pill) => pill.Med_Name_Generic);
          that.handler(preselectedMeds);
        });
    } else if (type === "psychiatry") {
      var promises = []
      promises.push(fetch('data/psychiatry_antidepressants.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_anxiolytic.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_antipsychotics.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_cognitiveagents.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_moodstabilizer.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_sleepingmeds.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_stimulants.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_substanceuse.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_antidepressants_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_anxiolytic_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_antipsychotics_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_cognitiveagents_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_moodstabilizer_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_sleepingmeds_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_stimulants_classes.json').then(function(response){return response.json()}))
      promises.push(fetch('data/psychiatry_substanceuse_classes.json').then(function(response){return response.json()}))


      //Permanent 
      promises.push(
        fetch('https://api.medbase.xyz/getpills/notes', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWT ${localStorage.getItem('token')}`
          }
        }).then(function(response){return response.json()})
      )


      Promise.all(promises).then(function(values){
        //TODO: Find a way to remove dup's in the backend
        let pills = [...values[0]["objects"], ...values[1]["objects"], ...values[2]["objects"], ...values[3]["objects"], ...values[4]["objects"], ...values[5]["objects"], ...values[6]["objects"], ...values[7]["objects"]];
        pills = removeDuplicates(pills, "Med_Name_Generic");
        let saved_notes = values[16]
        if (saved_notes) {
          for (var i = 0; i < pills.length; i++){
            for (var j = 0; j < saved_notes.length; j++){
              if (pills[i].id == saved_notes[j]['pill']){
                pills[i].Special_Notes = saved_notes[j]['note']
                pills[i]['Special_Notes_Changed'] = true
              }
            }
          }
        }

        let classes = [...values[8]["objects"], ...values[9]["objects"], ...values[10]["objects"], ...values[11]["objects"], ...values[11]["objects"], ...values[12]["objects"], ...values[13]["objects"], ...values[14]["objects"], ...values[15]["objects"]];
        classes = removeDuplicates(classes, "Med_Class");
        
        that.setState({"pillcardsobj": pills, "classcardsobj": classes});
        let tree = [
            { "disease": "Antidepressant", "tree": values[8]["objects"].map(toTreeStructure)},
            { "disease": "Anxiolytic", "tree": values[9]["objects"].map(toTreeStructure)},
            { "disease": "Antipsychotics", "tree": values[10]["objects"].map(toTreeStructure)},
            { "disease": "Cognitive agent", "tree": values[11]["objects"].map(toTreeStructure)},
            { "disease": "Mood Stabilizer", "tree": values[12]["objects"].map(toTreeStructure)},
            { "disease": "Sleeping Meds", "tree": values[13]["objects"].map(toTreeStructure)},
            { "disease": "Stimulants", "tree": values[14]["objects"].map(toTreeStructure)},
            { "disease": "Substance Use", "tree": values[15]["objects"].map(toTreeStructure)},
        ]
        that.setState({"priorities": tree});
        that.setState({"allpillnames": pills.map(a => a.Med_Name_Generic)});

        that.setInitHandlers([]);
      });
      }
    that.setState({"isLoading": false});
  }



  processDiabetes(that, data){
    let classes = data["classes"];
    let pills = data["pills"];
    that.setState({"pillcardsobj": pills, "classcardsobj": classes});
    let tree = classes.map(toTreeStructure);
    that.setState({"priorities": tree});
    that.setInitHandlers([]);
  }

  setInitHandlers(classes) {
    var MedClasses = [].concat.apply([], classes.map((classobj) => classobj.Med_Class));
    this.classhandler(MedClasses);
    var Meds = [].concat.apply([], classes.map((classobj) => classobj.Med_List.split(',')));
    this.handler([
      ...Meds
    ]);
  }

  handler(selectedItems) {
    var classes = this.state.classcardsobj;
    var finalItems = [];
    //If you have a parent selected but with no children, remove the parent
    for (var i = 0; i < selectedItems.length; i++) {
      var medclassobj = classes.filter((classobj) => classobj.Med_Class === selectedItems[i]);
      if (medclassobj[0]) {
        var his_children = medclassobj[0].Med_List.split(',');
        var child_exists = false;
        for (var j = 0; j < selectedItems.length; j++) {
          if (his_children.includes(selectedItems[j])) {
            child_exists = true;
          }
        }
        if (child_exists) {
          finalItems.push(selectedItems[i]); //TODO: If you are a child and all children are selected, add the parent
        }
      } else {
        finalItems.push(selectedItems[i]);
      }
    }
    this.setState({"selectedItems": finalItems, "checkedKeys": finalItems});
  }
  classhandler(selectedClasses) {
    this.setState({"selectedClasses": selectedClasses, "checkedKeys": selectedClasses})
  }

  handleSwitch(switchOption) {
    var option = switchOption.target.value;
    if (option) {
      this.setState({"checkedKeys": this.state.selectedClasses, "switchOption": option, "designatedHandler": this.classhandler})
    } else {
      this.setState({"checkedKeys": this.state.selectedItems, "switchOption": option, "designatedHandler": this.handler})
    }
  }

  designatedClearHandler(option) {
    this.handler([]);
    this.classhandler([]);
  }

  designatedDefaultHandler() {
    const {pillcardsobj} = this.state;

      let preselectedMeds = pillcardsobj.map((pill) => pill.Med_Name_Generic);
      this.handler(preselectedMeds);
  }

  removePillcardHandler(item, isPill) {
    let items;
    if (isPill) {
      items = this.state.selectedItems;
      items = items.filter(thing => thing !== item.Med_Name_Generic);
      this.handler(items);
    } else {
      items = this.state.selectedClasses;
      items = items.filter(thing => thing !== item.Med_Class);
      this.classhandler(items);
    }
  }

  updatePillcardObjectHandler(pillId, field_name, field_text) {
    let pill
    let pills
    for (let i = 0; i < this.state.pillcardsobj.length; i++){
      if (this.state.pillcardsobj[i].id == pillId) {
        pills = this.state.pillcardsobj
        if (field_name === "Frequency") {
          pills[i]["Frequency_es"] = field_text
        }
        pills[i][field_name] = field_text
        pills[i][field_name + "_Changed"] = true
        this.setState({"pillcardsobj": pills})

      }
    }
  }

  designatedDefaultClassHandler() {
    const {classcardsobj, pillcardsobj} = this.state;
    const {type} = this.props;

    if (type === "addiction") {
      let preselectedMeds = pillcardsobj.map((pill) => pill.Med_Name_Generic);
      this.handler(preselectedMeds);
    } else {
      let preselectedClasses = classcardsobj.map((pill) => pill.Med_Class);
      this.classhandler(preselectedClasses);
    }
  }

  handle_logout = () => {
    localStorage.removeItem('token');
    this.setState({ logged_in: false, username: '' });
  };


  handleLanguage(language) {
    this.setState({"language": language.target.value});
  }

  handleCost() {
    this.setState({"currCostTypeIndex": this.state.currCostTypeIndex ^ 1});
  }

  handleTreat() {
    this.setState({"currTreatTypeIndex": this.state.currTreatTypeIndex ^ 1});
  }

  handleComorbs(comorbs) {
    let sortedOptions = this.sortPriority(comorbs);
    this.setInitHandlers(sortedOptions.good);

  }

  handleSideEffects() {
    this.setState({"currSideEffectIndex": this.state.currSideEffectIndex ^ 1});
  }

  //Filters for class objects that are good, preferred and discouraged
  sortPriority = (comorbs) => {
    let classobj = this.state.classcardsobj;
    //for each class, if preferred out for any, put in bad, if preferred in (at least one was good), put in good, else, put in normal
    var bad = [];
    var good = [];
    var ok = [];

    for (var i = 0; i < classobj.length; i++) {
      var isBad = false;
      var isGood = false;
      for (var j = 0; j < comorbs.length; j++) {
        if (classobj[i].Rule_out && classobj[i].Rule_out.toLowerCase().includes(comorbs[j].toLowerCase())) {
          bad.push(classobj[i]);
          isBad = true;
          break;
        }
      }
      //all clear and we can consider for good things
      if (!isBad) {
        for (j = 0; j < comorbs.length; j++) {
          if (classobj[i].Preferred_In.toLowerCase().includes(comorbs[j].toLowerCase())) {
            good.push(classobj[i]);
            isGood = true;
            break;
          }
        }
        if (!isGood)
          ok.push(classobj[i])
      }
    }
    return {"good": good, "ok": ok, "bad": bad};
  }

  // Given the array of Med Class Names and Med Names Selected, obtain array of Med Objects.
  selectedCards() {
    var cards = [];
    //classcards info
    if (this.state.switchOption) {
      for (var i = 0; i < this.state.classcardsobj.length; i++) {
        for (var j = 0; j < this.state.selectedClasses.length; j++) {
          if (this.state.classcardsobj[i].Med_Class === this.state.selectedClasses[j])
            cards.push(this.state.classcardsobj[i]);
          }
        }
    } else {
      for (i = 0; i < this.state.pillcardsobj.length; i++) {
        for (j = 0; j < this.state.selectedItems.length; j++) {
          if (this.state.pillcardsobj[i].Med_Name_Generic === this.state.selectedItems[j])
            cards.push(this.state.pillcardsobj[i]);
          }
        }
    }
    return cards
  }

  createChangesJson() {
    // Filtering for cards currently chosen
    let cards = this.selectedCards()
    let ret = []
    // Find changed fields
    for (var i = 0; i < cards.length; i++) {
      if ('Special_Notes_Changed' in cards[i] || 'Frequency_Changed' in cards[i])
        ret.push({'id': cards[i].id, 'Special_Notes': cards[i].Special_Notes, 'Frequency': cards[i].Frequency})
    }
    return ret
  }

  createURL(keys) {
    var base_url = window.location.origin.includes("localhost")? "https://www.pillnotes.com" : window.location.origin
    if (keys.length === 0) {
      return document.URL
    } else {
      var url = base_url + '/getpills/' + keys[0].id;
      for (var i = 1; i < keys.length; i++) {
        url = url + ',' + keys[i].id;
      }
      return encodeURI(url)
    }
  }

  render() {
    let {priorities, isLoading, va, allpillnames} = this.state;
    let {type} = this.props;
    if (!isLoading) {
      return (
        <div className='page-div'>
          <Appbar>
            <div className='buttons-div'>
              {/* <LeftDrawer 
              type={type} 
              va={va} 
              switchOption={this.state.switchOption} 
              handleSwitch={this.handleSwitch} 
              language={this.state.language} 
              handleLanguage={this.handleLanguage} 
              cost={this.state.costTypes} 
              costIndex={this.state.currCostTypeIndex} 
              treatTypes={this.state.treatTypes} 
              treatsIndex={this.state.currTreatTypeIndex} 
              handleTreat={this.handleTreat} 
              handleCost={this.handleCost}>
              </LeftDrawer> */}
              <div className="button-div">
                <a href="/" className="home-button">
                  <img className="appbar-button" src={home} alt="share" height="35px" />
                  <div>Home</div>
                </a>
              </div>
              <SelectDialog
                type={type}
                designatedHandler={this.state.designatedHandler}
                checkedKeys={this.state.checkedKeys}
                designatedClearHandler={this.designatedClearHandler}
                switchOption={this.state.switchOption}
                designatedDefaultHandler={this.designatedDefaultHandler}
                filterOptions={allpillnames}
                designatedDefaultClassHandler={this.designatedDefaultClassHandler}>
                  
                <div className="left-text">
                <BetterTabs
                  type={type} designatedHandler={this.state.designatedHandler} checkedKeys={this.state.checkedKeys} switchOption={this.state.switchOption} filterOptions={priorities}>
                </BetterTabs>
                </div>
                <div className="center-text"/>
                </SelectDialog>
                {/* <ListItem>
                  <RadioGroup defaultValue={this.state.language} onChange={this.handleLanguage} size="large">
                    <RadioButton value="eng">English</RadioButton>
                    <RadioButton value="es">Spanish</RadioButton>
                  </RadioGroup>
                </ListItem> */}
                <div className="button-div">
                <SendDialog 
                  changes={this.createChangesJson()}
                  url={this.createURL(this.selectedCards())}
                  switchOption={this.state.switchOption}
                  cards={this.selectedCards()}/>
                </div>
            </div>
            <BackButton/>
            <div className='buttons-div'>
            {this.state.logged_in
           ?<div style={{marginTop: 10}}>
            <button style={{padding: "-10px"}} onClick={this.handle_logout}>
                <div className="button-logout">
                  Log Out
                </div>
            </button>
            </div>
            : <ColorButton style={{marginTop: 7, marginRight: 10, padding: "-10px"}} href="login">
                <div className="font-comfortaa">
                  Login
                </div>
            </ColorButton>
          }
          </div>
          </Appbar>
          <MyCarousel
            removePillcardHandler={this.removePillcardHandler}
            updatePillcardObjectHandler={this.updatePillcardObjectHandler}
            type={this.props.type} 
            cards={this.selectedCards()}
            language={this.state.language}
            cost={this.state.costTypes}
            costIndex={this.state.currCostTypeIndex}
            seIndex={this.state.currSideEffectIndex}
            toggleTreatsHandler={this.handleTreat}
            toggleCostHandler={this.handleCost}
            toggleSideEffectHandler={this.handleSideEffects}
            treatTypes={this.state.treatTypes}
            treatsIndex={this.state.currTreatTypeIndex}
            switchOption={this.state.switchOption}
            handleTreat={this.handleTreat} 
            handleCost={this.handleCost}
            handleSideEffects={this.handleSideEffects}/>
          
        </div>
      )
    }
    return "Loading...please wait";
  };
}

export default Pillcards;



// WEBPACK FOOTER //
// ./src/Pillcards/index.js